/* global gsap */

/**
 * @file
 * Cursor functionality.
 */

((Drupal, once) => {
  let _$cursor = null;
  let _pos = { x: 0, y: 0 };
  let _mouse = { x: 0, y: 0 };
  let _swiperHoverElements = null;
  const _speed = 0.7;
  const _swiperHoverClass = 'hovered--swiper';

  /**
   * On mouse over, show cursor.
   */
  function mouseOverHandlerSwiper(e) {
    if (!e.target.closest('.category-card__link')) {
      _$cursor.classList.add(_swiperHoverClass);
    } else {
      _$cursor.classList.remove(_swiperHoverClass);
    }
  }

  /**
   * On mouse leave, hide cursor.
   */
  function mouseLeaveHandlerSwiper() {
    _$cursor.classList.remove(_swiperHoverClass);
  }

  /**
   * Refresh hover elements.
   */
  function refreshHoverElements(e) {
    // Get all the swiper hover elements.
    _swiperHoverElements = document.body.querySelectorAll('[data-cursor-parent]');
  }

  /**
   * Remove hover event listeners.
   */
  function removeHoverEvents() {
    // If there are swiper elements.
    if (_swiperHoverElements.length > 0) {
      // Remove mouse over and leave events.
      _swiperHoverElements.forEach($element => {
        $element.removeEventListener('mouseover', mouseOverHandlerSwiper);
        $element.removeEventListener('mouseleave', mouseLeaveHandlerSwiper);
      });
    }
  }

  /**
   * Add hover event listeners.
   */
  function addHoverEvents() {
    // Remove any hover events.
    removeHoverEvents();

    // If there are swiper elements.
    if (_swiperHoverElements.length > 0) {
      // Add mouse over and leave events.
      _swiperHoverElements.forEach($element => {
        $element.addEventListener('mouseover', mouseOverHandlerSwiper);
        $element.addEventListener('mouseleave', mouseLeaveHandlerSwiper);
      });
    }
  }

  /**
   * Move cursor.
   */
  function moveCursor(e) {
    // Add a function to the gsap ticker (requestAnimationFrame).
    gsap.ticker.add(() => {
      // Adjust speed for higher refresh monitors.
      const dt = 1.0 - Math.pow(1.0 - _speed, gsap.ticker.deltaRatio());

      // Set new positions.
      _pos.x += (_mouse.x - _pos.x) * dt;
      _pos.y += (_mouse.y - _pos.y) * dt;

      gsap.set(_$cursor, {
        x: _pos.x + 'px',
        y: _pos.y + 'px',
      });
    });
  }

  /**
   * Move body handler.
   */
  function moveBodyHandler(e) {
    // Set the mouse position.
    _mouse = {
      x: e.clientX,
      y: e.clientY
    }
  }

  /**
   * Add mouse events.
   */
  function addMouseMoveEvent(e) {
    // Add a mouse move event to the body.
    document.body.addEventListener('mousemove', moveBodyHandler);
    document.body.addEventListener('pointermove', moveBodyHandler);
  }

  /**
   * Initialize cursor.
   *
   * @param props
   */
  function init(props) {
    _$cursor = props._$cursor;

    refreshHoverElements();
    addMouseMoveEvent();
    moveCursor();
    addHoverEvents();
  }

  Drupal.behaviors.cursor = {
    attach(context) {
      const _$cursor = once('cursor', '[data-cursor]', context).shift();

      // If there is a cursor.
      if (_$cursor) {
        init({_$cursor});
      }
    }
  };
})(Drupal, once);
